/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BusinessDefaultCostsCreateCustomBusinessDefaultCostParametersBody } from '../model/businessDefaultCostsCreateCustomBusinessDefaultCostParametersBody';
import { BusinessDefaultCostsCreateCustomBusinessDefaultCostParametersBody1 } from '../model/businessDefaultCostsCreateCustomBusinessDefaultCostParametersBody1';
import { BusinessDefaultCostsCreateCustomBusinessDefaultCostParametersBody2 } from '../model/businessDefaultCostsCreateCustomBusinessDefaultCostParametersBody2';
import { BusinessDefaultCostsCreateCustomBusinessDefaultCostParametersBody3 } from '../model/businessDefaultCostsCreateCustomBusinessDefaultCostParametersBody3';
import { BusinessDefaultCostsUpdateBusinessDefaultCostsParameterBody } from '../model/businessDefaultCostsUpdateBusinessDefaultCostsParameterBody';
import { BusinessDefaultCostsUpdateBusinessDefaultCostsParameterBody1 } from '../model/businessDefaultCostsUpdateBusinessDefaultCostsParameterBody1';
import { BusinessDefaultCostsUpdateBusinessDefaultCostsParameterBody2 } from '../model/businessDefaultCostsUpdateBusinessDefaultCostsParameterBody2';
import { BusinessDefaultCostsUpdateBusinessDefaultCostsParameterBody3 } from '../model/businessDefaultCostsUpdateBusinessDefaultCostsParameterBody3';
import { BusinessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody } from '../model/businessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody';
import { BusinessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody1 } from '../model/businessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody1';
import { BusinessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody2 } from '../model/businessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody2';
import { BusinessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody3 } from '../model/businessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody3';
import { CommandHandlerResponse } from '../model/commandHandlerResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BusinessDefaultCostsService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:POST/api/BusinessDefaultCosts/CreateCustomBusinessDefaultCostParameters AmsResource:{country}/{business}/_* 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createCustomBusinessDefaultCostParameter(body?: BusinessDefaultCostsCreateCustomBusinessDefaultCostParametersBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public createCustomBusinessDefaultCostParameter(body?: BusinessDefaultCostsCreateCustomBusinessDefaultCostParametersBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public createCustomBusinessDefaultCostParameter(body?: BusinessDefaultCostsCreateCustomBusinessDefaultCostParametersBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public createCustomBusinessDefaultCostParameter(body?: BusinessDefaultCostsCreateCustomBusinessDefaultCostParametersBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandHandlerResponse>(`${this.basePath}/api/BusinessDefaultCosts/CreateCustomBusinessDefaultCostParameters`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:PUT/api/BusinessDefaultCosts/UpdateBusinessDefaultCostsParameter AmsResource:{country}/{business}/_* 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBusinessDefaultCostsParameter(body?: BusinessDefaultCostsUpdateBusinessDefaultCostsParameterBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public updateBusinessDefaultCostsParameter(body?: BusinessDefaultCostsUpdateBusinessDefaultCostsParameterBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public updateBusinessDefaultCostsParameter(body?: BusinessDefaultCostsUpdateBusinessDefaultCostsParameterBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public updateBusinessDefaultCostsParameter(body?: BusinessDefaultCostsUpdateBusinessDefaultCostsParameterBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CommandHandlerResponse>(`${this.basePath}/api/BusinessDefaultCosts/UpdateBusinessDefaultCostsParameter`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:PUT/api/BusinessDefaultCosts/UpdateCustomBusinessDefaultCostParameter AmsResource:{country}/{business}/_* 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCustomBusinessDefaultCostParameter(body?: BusinessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public updateCustomBusinessDefaultCostParameter(body?: BusinessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public updateCustomBusinessDefaultCostParameter(body?: BusinessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public updateCustomBusinessDefaultCostParameter(body?: BusinessDefaultCostsUpdateCustomBusinessDefaultCostParameterBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CommandHandlerResponse>(`${this.basePath}/api/BusinessDefaultCosts/UpdateCustomBusinessDefaultCostParameter`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
